module.exports = __webpack_public_path__ + "img/menu-sx.3d7cb644.png";